module.exports = __webpack_public_path__ + "static/case_10-98e9ec2bf36e52bd58dd68e909ab12c8.jpg";